// extracted by mini-css-extract-plugin
export default {"container":"between_container__tUKpU","separator":"between_separator__ENjDZ"};